import AppRoute from "models/AppRoute"
import { ReservationCartCopyFlag } from "models/ReservationCart"
import { Guid } from "@/types"

interface IReservationCopyRouteParams {
    reservationId: Guid
}

interface IReservationCopyRouteQuery {
    copyFlag?: ReservationCartCopyFlag
    backUrl?: string
}

const ReservationCopyRoute = new AppRoute<IReservationCopyRouteParams, IReservationCopyRouteQuery>({
    route: "/reservation/:reservationId/copy",
    navbar: true,
    authRequired: true,
})

export default ReservationCopyRoute
